import axiosInstance from "api/axiosInstance";
import { provinceExpireReceiptsAction } from "./province-expire-receipts-slice";
import { batch } from "react-redux";
import exportAxiosInstance from "api/exportAxiosInstance";
import FileSaver from "file-saver";

// Get Province Expire Receipts
export const getProvinceExpireReceipts =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null,
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(provinceExpireReceiptsAction.setLoading(true));
    url = url || "/v1/get-province-expire-receipts";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          batch(() => {
            dispatch(provinceExpireReceiptsAction.setError(null));
            dispatch(provinceExpireReceiptsAction.setData(response.data));
            dispatch(provinceExpireReceiptsAction.setLoading(false));
          });
        }
      })
      .catch((error) => {
        dispatch(provinceExpireReceiptsAction.setLoading(false));
        console.log(error);
      });
  };

// Get Province Total Expire Receipts Count

export const getProvinceTotalExpireReceiptsCount = () => (dispatch) => {
  dispatch(provinceExpireReceiptsAction.setCount(0));
  axiosInstance
    .get("/v1/get-province-expire-receipts-count")
    .then((response) => {
      if (response) {
        batch(() => {
          dispatch(provinceExpireReceiptsAction.setCount(response?.data));
        });
      }
    })
    .catch((error) => {
      dispatch(provinceExpireReceiptsAction.setCount(0));
      console.log(error);
    });
};

// Export Province In Expire Receipts

export const exportProvinceInExpireReceipts =
  (advancedSearch = {}) =>
  (dispatch) => {
    dispatch(
      provinceExpireReceiptsAction.setExportStatus({
        loading: true,
        error: null,
      })
    );

    exportAxiosInstance
      .get("/v1/export-province-expire-receipts", {
        params: advancedSearch,
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Province-In-${Math.random().toString()}.xlsx`
          );
          dispatch(
            provinceExpireReceiptsAction.setExportStatus({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          provinceExpireReceiptsAction.setExportStatus({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };
